export default __webpack_public_path__ + "static/media/meat.a4096908.webp";